import { faEye, faSave } from '@fortawesome/free-solid-svg-icons';
import IconButton from 'components/common/IconButton';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

/* DashboardEditControls component
 * This component renders a set of controls for editing a dashboard.  
* It includes buttons for switching to view mode, adding a widget, and saving the layout. */

export default function DashboardEditControls({
  onViewClick,
  onAddWidgetClick,
  onSaveLayoutClick
}) {
  return (
    <Col md="auto" className="mb-3 mb-md-0">
      <Row className="g-3 gy-md-0 h-100 align-items-center">
        <Col xs="auto">
          <IconButton
            size="sm"
            variant="falcon-primary"
            iconClassName="me-2"
            icon={faEye}
            onClick={onViewClick}
          >
            Switch to View
          </IconButton>
        </Col>

        <Col xs="auto">
          <IconButton
            size="sm"
            variant="falcon-primary"
            iconClassName="me-2"
            icon="plus"
            onClick={onAddWidgetClick}
          >
            Add Widget
          </IconButton>
        </Col>
        <Col xs="auto">
          <IconButton
            size="sm"
            variant="falcon-primary"
            iconClassName="me-2"
            icon={faSave}
            onClick={onSaveLayoutClick}
          >
            Save Layout
          </IconButton>
        </Col>
      </Row>
    </Col>
  );
}

// PropTypes for the DashboardEditControls component
DashboardEditControls.propTypes = {
  onViewClick: PropTypes.func.isRequired,
  onAddWidgetClick: PropTypes.func.isRequired,
  onSaveLayoutClick: PropTypes.func.isRequired
};